import styled from "@emotion/styled";

export const DashboardPageWrapper = styled.div({
  display: "grid",
  gap: 24,
  paddingBottom: 40,
});

export const DashboardPageContainer = styled.div({
  width: "min(100%, 1200px)",
  margin: "0 auto",
});
